import { Component, EventEmitter, OnInit, OnDestroy, AfterViewInit, Output, ElementRef } from '@angular/core';
import { BasicService } from '../../services/basic.service';
import { EmojisService } from './emojis.service';
import { MostUsedEmojis } from './most-used-emojis';

@Component({
  selector: 'app-emojis-list',
  templateUrl: './emojis-list.component.html',
  styleUrls: ['./emojis-list.component.scss'],
})
export class EmojisListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() emojiClicked = new EventEmitter<string>();

  displayedMostUsedEmojisAndTheirIndex: { emoji: string; spriteIndex: number }[];

  private mostUsedEmojis: MostUsedEmojis;
  private clickListenerFn = event => this.onEmojiClicked(event);

  constructor(
    private elementRef: ElementRef,
    private basicService: BasicService,
    private emojisService: EmojisService
  ) {}

  ngOnInit() {
    this.emojisService.getUsageCounts().subscribe(mostUsedEmojis => {
      this.mostUsedEmojis = mostUsedEmojis;
      this.displayedMostUsedEmojisAndTheirIndex = mostUsedEmojis.sortedEmojiUsages
        .slice(0, 30) // keep 30 here, and we also have CSS to only display one line
        .map(usage => ({
          emoji: usage.emoji,
          spriteIndex: this.emojisService.emojiIndex(usage.emoji),
        }));
    });
  }

  ngAfterViewInit() {
    // build DOM here becase *ngFor on 1500+ emojis is too slow in IE11
    const container = this.basicService.document.createElement('div');
    for (const category of this.emojisService.allEmojisByCategory()) {
      container.appendChild(this.buildCategoryDOM(category));
    }
    this.elementRef.nativeElement.addEventListener('click', this.clickListenerFn, false);
    this.elementRef.nativeElement.appendChild(container);
  }

  ngOnDestroy() {
    this.elementRef.nativeElement.removeEventListener('click', this.clickListenerFn, false);
  }

  onEmojiClicked(event) {
    const emoji = event.target.getAttribute('data-emoji');
    if (emoji) {
      this.emojiClicked.emit(emoji);
      if (this.mostUsedEmojis) {
        this.mostUsedEmojis.registerUsage(emoji);
        this.emojisService.updateUsageCounts(this.mostUsedEmojis).subscribe();
      }
    }
  }

  private buildCategoryDOM(category) {
    const section = document.createElement('section');
    section.className = 'alc-emoji-section';
    const title = document.createElement('div');
    title.className = 'alc-emoji-category-name';
    title.textContent = this.basicService.translate(category.name);
    section.appendChild(title);
    const emojis = document.createElement('div');
    emojis.className = 'alc-emojis';
    for (const emojiString of category.charList) {
      const emojiDiv = document.createElement('div');
      emojiDiv.setAttribute('data-emoji', emojiString);
      const emojiIndex = this.emojisService.emojiIndex(emojiString);
      emojiDiv.setAttribute('style', `background-position: -${emojiIndex * 26}px 0`);
      emojis.appendChild(emojiDiv);
    }
    section.appendChild(emojis);
    return section;
  }
}
